import { css } from '@emotion/core';
import { minimumWidth, styled } from '@feast-it/ui/light';

export const Container = styled.div(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing[10]};

    // Offset SliceLayout margin-bottom
    margin-bottom: -${theme.spacing[6]};

    ${minimumWidth(theme.breakpoints.medium)} {
      margin-bottom: -${theme.spacing[8]};
    }

    ${minimumWidth(theme.breakpoints.large)} {
      margin-bottom: -${theme.spacing[10]};
    }
  `
);
